import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface OnboardingState {
  showOnboarding: boolean;
  selectedProjectId: string | null;
  activeSettingsContent: "appInfo" | "triggers" | "feedback" | "sdk";
  checkedItems: {
    triggers: boolean;
    feedbackForms: boolean;
    // theme: boolean;
    dashboard: boolean;
  };
}

const initialState: OnboardingState = {
  showOnboarding: localStorage.getItem("showOnboarding") !== "false",
  selectedProjectId: null,
  activeSettingsContent: "appInfo",
  checkedItems: JSON.parse(
    localStorage.getItem("onboardingCheckedItems") ||
      '{"triggers":false,"feedbackForms":false,"dashboard":false}',
  ),
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    dismissOnboarding: (state) => {
      console.log("dismissOnboarding");
      state.showOnboarding = false;
      state.selectedProjectId = null;
      localStorage.setItem("showOnboarding", "false");
    },
    resetOnboarding: (state) => {
      console.log("resetOnboarding");
      state.showOnboarding = true;
      state.selectedProjectId = null;
      state.checkedItems = {
        triggers: false,
        feedbackForms: false,
        dashboard: false,
      };
      localStorage.removeItem("showOnboarding");
      localStorage.removeItem("onboardingCheckedItems");
    },
    setSelectedProject: (state, action: PayloadAction<string>) => {
      console.log("setSelectedProject", action.payload);
      state.selectedProjectId = action.payload;
    },
    clearSelectedProject: (state) => {
      console.log("clearSelectedProject");
      state.selectedProjectId = null;
    },
    setActiveSettingsContent: (
      state,
      action: PayloadAction<OnboardingState["activeSettingsContent"]>,
    ) => {
      console.log("setActiveSettingsContent", action.payload);
      state.activeSettingsContent = action.payload;
    },
    setCheckedItem: (
      state,
      action: PayloadAction<{
        key: keyof OnboardingState["checkedItems"];
        value: boolean;
      }>,
    ) => {
      console.log("setCheckedItem", action.payload);
      state.checkedItems[action.payload.key] = action.payload.value;
      localStorage.setItem(
        "onboardingCheckedItems",
        JSON.stringify(state.checkedItems),
      );
    },
  },
});

// Selectors
export const selectShowOnboarding = (state: RootState) =>
  state.onboarding.showOnboarding &&
  state.onboarding.selectedProjectId !== null;
export const selectSelectedProjectId = (state: RootState) =>
  state.onboarding.selectedProjectId;
export const selectActiveSettingsContent = (state: RootState) =>
  state.onboarding.activeSettingsContent;

export const {
  dismissOnboarding,
  resetOnboarding,
  setSelectedProject,
  clearSelectedProject,
  setActiveSettingsContent,
  setCheckedItem,
} = onboardingSlice.actions;
export default onboardingSlice.reducer;
